import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { EnvMergeService } from '@core/services/env-merge.service';
import { IArticle } from '@pages/articles/interfaces/article.interface';
import { Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { ArticlesDataService } from '../services/articles.data.service';

export const articleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<UrlTree | boolean> => {
  const router = inject(Router);
  const articlesService = inject(ArticlesDataService);
  const mergeEnvService = inject(EnvMergeService);

  const id: string = route.params['id'];

  return mergeEnvService.mergedEnv$.pipe(
    switchMap((): Observable<IArticle> => articlesService.getArticle(id)),
    map((article: IArticle): UrlTree | boolean => !!article || router.createUrlTree(['/404'])),
  );
};
